import { AxiosResponse as axiosResponse } from "axios";
import { HttpStatusCode } from "axios";

export default function AxiosResponse(response: axiosResponse): axiosResponse {
  if (response.status === 200) {
    return response.data;
  }
  return response;
}
